module.exports = __webpack_public_path__ + "fonts/Franklin-gothic-heavy.0334105.woff2";